var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-list-item-group',_vm._l((_vm.list),function(item,i){return _c('v-list-item',{key:i,class:{
      'v-item--active': _vm.active === item.id,
    },style:({
      'padding-left': (_vm.level + 1) * 16 + 'px'
    }),attrs:{"active-class":"none-style","to":item.goto}},[_c('v-list-item-icon',[_c('v-icon',{domProps:{"textContent":_vm._s(item.icon)}})],1),_c('v-list-item-content',[_c('v-list-item-title',{domProps:{"textContent":_vm._s(_vm.$t(item.label))}})],1)],1)}),1)}
var staticRenderFns = []

export { render, staticRenderFns }